import { Collection } from "@tblabs/truffle";
import { ProductOption } from "./ProductOption";


export class ProductOptions
{
    public List = new Collection<ProductOption>();
    
    public GetById(url: string): ProductOption
    {
        return this.List.Items.find(x => x.Url.value == url) ?? ProductOption.Default();
    }

    public FactorAsLabel(url: string): string
    {
        const option = this.List.Items.find(x => x.Url.value == url) ?? ProductOption.Default();
    
        const factor = option.PriceFactor.value;
        if (factor == 1)
            return "";
        else if (factor > 1)
            return `(+${((factor - 1) * 100).toFixed(0)}% do ceny)`;
        else
            return `(${((1 - factor) * 100).toFixed(0)}% taniej)`;
    }

    public GetPriceFactor(optionId: string): number
    {
        return this.List.Items.find(x => x.Url.value == optionId)?.PriceFactor?.value ?? 1;
    }
}
